import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import {bindActionCreators} from 'redux';
import MessageList from './MessageList';
//import ConversationClass from '/chat/src/lib/Conversation';
import TypingIndicatorChatBody from './TypingIndicatorChatBody';
import UnreadMessageIndicatorChatBody from './UnreadMessageIndicatorChatBody';

import {TicketModel, SystemModel, CompanyModel, UserModel} from '/chat/src/redux/model'

const events = require('add-event-listener');

class ChatBody extends Component {
    constructor() {
        super();
        this.handleChatBodyScroll = this.handleChatBodyScroll.bind(this);
        this.hasScrolledUpState = false;
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.previousScrollHeight = 0;

        this.visibilityChange = this.visibilityChange.bind(this);
    }

    componentDidMount(){
        this.scrollToBottom();
        if(this.props.room && this.props.unread){
            this.props.dispatch(TicketModel.requestSetTicketToRead(this.props.room))
        }
        events.addEventListener(this.chatBody, 'scroll', this.handleChatBodyScroll);
        window.document.addEventListener("visibilitychange", this.visibilityChange)
    }

    componentWillUnmount() {
        events.removeEventListener(this.chatBody, 'scroll', this.handleChatBodyScroll);

    }

    componentDidUpdate(prevProps){
        const currentConversationRoom = this.props.room;
        if(!currentConversationRoom) return;

        const entries = this.props.entries;
        const prevEntries = prevProps.entries;
        if(this.chatBody.scrollTop === 0){
            // we scrolled top and receive new entries
            // reset back the scroll
            this.chatBody.scrollTop = this.chatBody.scrollHeight - this.previousScrollHeight;
            return;
        }
        if(this.hasScrolledUp()){
            if (entries.size !== prevEntries.size) {
                this.scrollToBottom();
            }
        }
        this.shouldSetAllEntriesToRead();
    }

    render() {
        // TODO
        //{this.renderUnreadMessageIndicatorChatBody()}
        // NOTE: button at bottom take 63 px;
        const height = this.props.height - 63 + 'px'
        return (
            <div class='chat-body' ref={(chatBody) => { this.chatBody = chatBody; }} style={{height: height}}>
                <MessageList />

                {this.props.typing &&  <TypingIndicatorChatBody/>}
            </div>
        );
    }

    renderUnreadMessageIndicatorChatBody() {
        const currentConversationRoom = this.props.room;
        const unreadEntriesCount = this.props.unreadEntriesCount;
        if(!currentConversationRoom) return;
        const unreadRoomEntriesCount = unreadEntriesCount.get(currentConversationRoom);
        if(!unreadRoomEntriesCount) return;
        if (unreadRoomEntriesCount > 0){
           return <UnreadMessageIndicatorChatBody unreadCount={unreadRoomEntriesCount} scrollToBottomOfChatBody={this.scrollToBottom} />
        }
    }

    visibilityChange(){
        const visibleState = window.document.visibilityState;
        let visible = false;

        if(visibleState == 'visible'){
            visible = true;
        }

        this.props.dispatch(SystemModel.setTabFocus(visible))
    }


    handleChatBodyScroll() {
        this.hasScrolledUpState = this.hasScrolledUp()
        if(this.chatBody.scrollTop === 0){
            this.previousScrollHeight = this.chatBody.scrollHeight
            const room = this.props.room;
            const entries = this.props.entries;
            const offset = entries.size;
            this.props.dispatch(TicketModel.requestEntriesGet(room, offset))
        }
        this.shouldSetAllEntriesToRead();
    }

    shouldSetAllEntriesToRead() {
        if(!this.props.room) return;
        if(!this.props.unread) return;
        if(!this.isAtBottomOfChatBody) return;
        if(!this.props.currentTab) return;
        if(!this.props.bubbleButtonState) return;
        if(!this.props.browserTabFocus) return;

        this.props.dispatch(TicketModel.requestSetTicketToRead(this.props.room))
    }

    scrollToBottom() {
        //const currentConversationRoom = this.props.room;
        //actionSetAllEntriesToRead(currentConversationRoom);
        if (this.chatBody) {
            setTimeout(() => {
                this.setChatBodyScrollTop(100000000000000);
            }, 0);
        }
    }

    setChatBodyScrollTop(scrollTop) {
        this.chatBody.scrollTop = scrollTop;
    }

    isAtBottomOfChatBody() {
        return this.chatBody.scrollHeight === this.chatBody.scrollTop + this.chatBody.offsetHeight;
    }

    hasScrolledUp() {
        return !this.isAtBottomOfChatBody();
    }
}

function mapStateToProps(state) {
    const room = TicketModel.getCurrentRoom(state)
    const entries = TicketModel.getEntries(room, state)
    const eId = TicketModel.getAssignedEmployeeId(room, state)
    const assignedEmployee = CompanyModel.getEmployee(eId, state)
    const userId = UserModel.getId(state)
    const currentTab = SystemModel.getActiveTab(state);
    const bubbleButtonState = SystemModel.getBubbleButtonState(state);
    const browserTabFocus = SystemModel.getBrowserTabFocus(state);


    return {
        entries: entries,
        room: room,
        assignedEmployee: assignedEmployee,
        height: SystemModel.getBodyHeight(state),
        unread: TicketModel.getUnread(room, state),
        userId: userId,
        typing: TicketModel.getTyping(room, state),
        currentTab: currentTab,
        bubbleButtonState: bubbleButtonState,
        browserTabFocus: browserTabFocus
    };
}
export default connect(mapStateToProps)(ChatBody);



// WEBPACK FOOTER //
// ./routes/Chat/Chat/ChatBody.js